/* eslint-disable no-underscore-dangle */

const _ = require("lodash");
const moment = require("moment");
// require("moment-duration-format");

class UptimeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("uptime-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /** ***************************************** */
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /** ***************************************** */
    _shutdown() {
        const prom = new Promise((resolve /* ,reject */) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("Uptime", (this._onUptime = this._onUptime.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Uptime");
    }

    /** **************************************** */
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /** **************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        const prom = new Promise((resolve /* ,reject */) => {
            this._setUptime(this._model.getValue());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }
    /** **************************************** */
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /** **************************************** */

    _onUptime(newVal) {
        this._setUptime(newVal);
    }

    /** **************************************** */
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /** **************************************** */

    _setUptime(newVal) {
        if (!_.isUndefined(newVal)) {
            const format = `${
                _.get(moment.duration(newVal, "milliseconds"), "_data.years", 0) > 0 ? "Y[y]" : ""
            } M[m] d[d] h[h] m[m]`;
            const uptime = moment.duration(newVal, "milliseconds").format(format, {trim: false});
            this._rootElem.innerHTML = uptime;
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /** **************************************** */
    /*  END PRIVATE API METHODS */
    /** **************************************** */
}

export default UptimeRenderer;
